import { Typography } from "@mui/material";
import { PatternFormat, PatternFormatProps } from "react-number-format";
import { NoData } from "./NoData";
import { CommonFieldProps } from "./types";

type PatternFieldProps = CommonFieldProps & PatternFormatProps;

export const PatternField = ({
  name,
  data,
  getValue,
  ...rest
}: PatternFieldProps) => {
  const value = getValue ? getValue(data) : data[name];

  return value ? (
    <Typography>
      <PatternFormat
        {...rest}
        value={value}
        displayType="text"
        valueIsNumericString
      />
    </Typography>
  ) : (
    <NoData />
  );
};
